import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a786428e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media children" }
const _hoisted_2 = {
  key: 0,
  class: "albums"
}
const _hoisted_3 = {
  key: 1,
  class: "not-found c-secondary"
}
const _hoisted_4 = {
  key: 1,
  class: "shorts"
}
const _hoisted_5 = {
  key: 0,
  class: "not-found c-secondary"
}
const _hoisted_6 = {
  key: 2,
  class: "articles"
}
const _hoisted_7 = {
  key: 0,
  class: "not-found c-secondary"
}
const _hoisted_8 = {
  key: 3,
  class: "authors"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "name" }
const _hoisted_11 = {
  key: 0,
  class: "not-found c-secondary"
}
const _hoisted_12 = {
  key: 4,
  class: "comments"
}
const _hoisted_13 = { class: "list" }
const _hoisted_14 = { class: "item c-border" }
const _hoisted_15 = { class: "avatar" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "item-info" }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { class: "space" }
const _hoisted_20 = { class: "c-thirdary" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = {
  key: 0,
  class: "write"
}
const _hoisted_23 = ["placeholder"]

import userApi from '@/api/userApi';
import { isMobile } from '@/common/download';
import { setting } from '@/config';
import channel, { State } from '@/store/channels/channel';
import home from '@/store/channels/home';
import i18, { State as I18State } from '@/store/i18';
import user, { State as UserState } from '@/store/user';
import Avatar from '@/views/components/Avatar.vue';
import Pagination from '@/views/components/Pagination.vue';
import * as filters from '@/views/filters';
import { computed, onMounted, reactive, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import ArticleItem from '../ArticleItem.vue';
import MovieItem from '../MovieItem.vue';
import ShortItem from '../ShortItem.vue';
import ChannelInfo from './ChannelInfo.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const channelId = computed(() => parseInt(route.params.id as string))
const store = useStore()
const leftData = computed(() => store.state[home.name].left)
const data = computed<State>(() => store.state[channel.name])
const userData = computed<UserState>(() => store.state[user.name]);
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])
const channelLang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].channel)

const temp = reactive({
    loading: false,
    text: '',
    favorite: false,
})

onMounted(() => {
    if (userData.value.info) {
        checkMyFavorite()
    }
    if (isMobile() && setting.first) {
        window.location.href = 'fuyintv://ttlx/bible/' + channelId.value
    }
})

watch(channelId, () => {
    if (userData.value.info) {
        checkMyFavorite()
    }
})

async function checkMyFavorite() {
    if (leftData.value.channels.length > 0) {
        temp.favorite = leftData.value.channels.some((item: any) => item.id == channelId.value)
    }
    temp.favorite = await userApi.isMyChannel(channelId.value)
}

function onMovie(id: number) {
    router.push(`/channels/movies/${id}.html`)
}

function onArticle(id: number) {
    router.push(`/channels/articles/${id}.html`)
}

function onArtist(id: number) {
    router.push(`/channels/authors/${id}/index.html`)
}


async function onSubmit() {
    let text = temp.text.trim()
    if (!text) {
        return
    }
    if (temp.loading) {
        return
    }
    try {
        temp.loading = true
        await userApi.submitChannelComment(data.value.info.id, text)
        temp.text = ''
    } finally {
        temp.loading = false
    }
}

function onPageChange(page: number) {
    router.push(`/channels/detail/${data.value.info.id}/movies/pages/${page}.html`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ChannelInfo),
    _createElementVNode("div", _hoisted_1, [
      (_unref(data).currNav == 'album')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(data).movies.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).movies, (item) => {
                    return (_openBlock(), _createBlock(MovieItem, {
                      album: item,
                      onClick: ($event: any) => (onMovie(item.movid))
                    }, null, 8, ["album", "onClick"]))
                  }), 256)),
                  _createVNode(Pagination, {
                    total: _unref(data).total,
                    page: _unref(data).page,
                    size: _unref(data).pageSize,
                    onChange: onPageChange
                  }, null, 8, ["total", "page", "size"])
                ], 64))
              : _createCommentVNode("", true),
            (_unref(data).movies.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(lang).movieText.empty), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(data).currNav == 'short_video')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).shorts, (item) => {
              return (_openBlock(), _createBlock(ShortItem, { item: item }, null, 8, ["item"]))
            }), 256)),
            (_unref(data).shorts.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(lang).movieText.empty), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(data).currNav == 'yuedu')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).articles, (item) => {
              return (_openBlock(), _createBlock(ArticleItem, {
                item: item,
                onClick: ($event: any) => (onArticle(item.itemid))
              }, null, 8, ["item", "onClick"]))
            }), 256)),
            (_unref(data).articles.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(lang).movieText.empty), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(data).currNav == 'speaker')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).artists, (item) => {
              return (_openBlock(), _createElementBlock("a", {
                class: "link line",
                onClick: ($event: any) => (onArtist(item.id))
              }, [
                _createVNode(Avatar, {
                  url: item.thumb
                }, null, 8, ["url"]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1)
              ], 8, _hoisted_9))
            }), 256)),
            (_unref(data).artists.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(lang).movieText.empty), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(data).currNav == 'response')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).comments, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      src: item.user.avatar_url
                    }, null, 8, _hoisted_16)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(item.user.nickname), 1),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(filters).datetime(item.createtime)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(item.content), 1)
                  ])
                ]))
              }), 256))
            ]),
            (_unref(userData).info)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("textarea", {
                    class: "c-primary",
                    placeholder: _unref(channelLang).comment,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(temp).text) = $event)),
                    maxlength: "200"
                  }, null, 8, _hoisted_23), [
                    [_vModelText, _unref(temp).text]
                  ]),
                  _createElementVNode("a", { onClick: onSubmit }, _toDisplayString(_unref(channelLang).submit), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})